import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Row, Col, Card, Dropdown,DropdownButton } from "react-bootstrap";
import DealTab from "./DealTab";
import DealTradesTab from "./DealTradesTab";
import DealDetail from "./DealDetail";
import { getDeals,getDealTrades, refreshDealStatus } from "../../actions/deal-action";
import { DealStatus,TradeListStatuses,TradeListSides,TradeOrders,TradeOrderNames } from "../../Const";
import ContentContainer from "../common/ContentContainer";
import CustomPagination from "../common/CustomPagination";
import {getKeyByValue} from "../../utils/Utils";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const Deals = (props) => {
  const { getDeals,getDealTrades ,refreshDealStatus} = props;
  const [showDetail, setShowDetail] = useState(-1);
  const [completed, setCompleted] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, getSelectedTab] = useState('open');
  const [tradeStatus, setTradeStatus] = useState('');
  const [tradeOrderName, setTradeOrderName] = useState('');
  const [tradeSide, setTradeSide] = useState('');
  const {t} = useTranslation()

  const tabTitles = [t("open-deals"), t("c-deals"),t("trade-log")];
  const tourClasses = ["open-deals-tour", "completed-deals-tour","trade-logs-tour"];

  var deals = useSelector((state) => state.deals.deals) || [];
  var trades = useSelector((state) => state.deals.trades) || [];
  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const filters = useSelector((state) => state.settings.filters) || [];
  deals = deals.filter((el) => el.exchange_id == selectedExchangeId);
  const completedStatuses = [
    DealStatus.stopLoss,
    DealStatus.takeProfit,
    DealStatus.exited,
    DealStatus.liquidated,
    DealStatus.error,
  ];
  const itemsPerPage = 10;
  const pageNum=1;
  const completedDeals = (deals || []).filter((deal) =>
    completedStatuses.includes(deal.status_key)
  );
  const incompletedDeals = (deals || []).filter(
    (deal) => !completedStatuses.includes(deal.status_key)
  );
  const totalDeals = useSelector((state) => state.deals.totalDeals) || 0;
  const totalTrades = useSelector((state) => state.deals.totalTrades) || 0;
  const startItem = useSelector((state) => state.deals.startItem) || 1;
  const tradeStartItem = useSelector((state) => state.deals.tradeStartItem) || 1;
  useEffect(() => {
    getDeals(selectedExchangeId,itemsPerPage,pageNum,selectedTab);
    //getDealTrades(selectedExchangeId,itemsPerPage,pageNum,tradeStatus,tradeSide,tradeOrderName);
  }, [selectedExchangeId]);

  useEffect(() => {
    getDealTrades(selectedExchangeId,itemsPerPage,pageNum,tradeStatus,tradeSide,tradeOrderName);
  }, [selectedExchangeId,tradeStatus,tradeSide,tradeOrderName]);
  
  
  const tabHeaders = tabTitles.map((item, index) => {
    return (
      <Col xs={4} xl={2} key={index}>
        <a
          onClick={() => changeTab(index,index==0?'open':'close')}
          className={(index == activeTab ? "tab-active" : "tab-inactive" )+ " "+ tourClasses[index]}
        >
          {item}
        </a>
      </Col>
    );
  });
  const tradeStatusItems = Object.keys(TradeListStatuses).map((item, index) => {
    return (
      <Dropdown.Item key={index} eventKey={item}>
        {t(TradeListStatuses[item])}
      </Dropdown.Item>
    );
  });
  const tradeSideItems = Object.keys(TradeListSides).map((item, index) => {
    return (
      <Dropdown.Item key={index} eventKey={item}>
        {t(TradeListSides[item])}
      </Dropdown.Item>
    );
  });
  const tradeOrderNameItems = Object.keys(TradeOrders).map((item, index) => {
    return (
      <Dropdown.Item key={index} eventKey={index}>
        {t(TradeOrderNames[item])}
      </Dropdown.Item>
    );
  });
  const changeTab = (index,tab) => {
    setActiveTab(index);
    getSelectedTab(tab)
    getDeals(selectedExchangeId,itemsPerPage,pageNum,tab)
  };

  const dealTabs = [
    <DealTab
      deals={incompletedDeals}
      t={t}
      completed={false}
      onShowDetail={(id) => {
        setShowDetail(id);
        setCompleted(false);
      }}
      refreshDeal={(id) => {
        return new Promise((resolve,reject)=>{
          refreshDealStatus(id,selectedExchangeId,itemsPerPage,pageNum,selectedTab).then((message)=>{
            toast.success(message)
            resolve(message)
          }).catch((error)=>{
            toast.error(error)
            reject(error)
          })
        })
        
      }}
    />,
    <DealTab
      deals={completedDeals}
      t={t}
      completed={true}
      onShowDetail={(id) => {
        setShowDetail(id);
        setCompleted(true);
      }}
    />,
    <DealTradesTab
      t={t}
      trades={trades}
    />
  ];

  const filterItem = filters.map((item, index) => {
    return (
      <Dropdown.Item key={index} eventKey={index}>
        {item.name}
      </Dropdown.Item>
    );
  });

  return (
   
    <ContentContainer url="deals" title={t("deals")} showExchange={true}>
      <div className="m-1">
        
        <Row>
          <Col>
            <div style={{ padding: 30,position:'relative' }}>
              <Row noGutters>{tabHeaders}</Row>
              {activeTab == 2 && (<Row className="mt-4 mb-1" style={{float:'right'}}>
                  <div className="mb-1 mr-2" style={{minWidth:'150px'}}>
                  <DropdownButton
                    title={tradeStatus?TradeListStatuses[tradeStatus]:'Status'}
                    onSelect={(index) => setTradeStatus(index)}
                    variant="outline-primary"
                  >
                    {tradeStatusItems}
                  </DropdownButton>
                  </div>
                <div className="mb-1 mr-2" style={{minWidth:'150px'}}>
                  <DropdownButton
                    title={tradeSide?TradeListSides[tradeSide]:'Side'}
                    onSelect={(index) => setTradeSide(index)}
                    variant="outline-primary"
                  >
                    {tradeSideItems}
                  </DropdownButton>
                </div>
                <div className="mb-1 mr-2" style={{minWidth:'150px'}}>
                  <DropdownButton
                    title={tradeOrderName?TradeOrderNames[getKeyByValue(TradeOrders,tradeOrderName)]:'Order'}
                    onSelect={(index) => setTradeOrderName(TradeOrders[index])}
                    variant="outline-primary"
                  >
                    {tradeOrderNameItems}
                  </DropdownButton>
                </div>
              </Row> )}
              {dealTabs[activeTab]}
            </div>
            <div className="bottom-center">
                {activeTab != 2 ? ( <CustomPagination
                  itemsCountPerPage={itemsPerPage}
                  startItem={startItem}
                  selectedTab={selectedTab}
                  totalCount={totalDeals}
                  onChange={getDeals}
                  selectedExchangeId={selectedExchangeId}
                  itemsPerPage={itemsPerPage}
                /> ) : 
                (<CustomPagination
                  itemsCountPerPage={itemsPerPage}
                  startItem={tradeStartItem}
                  totalCount={totalTrades}
                  onChange={getDealTrades}
                  selectedExchangeId={selectedExchangeId}
                  itemsPerPage={itemsPerPage}
                />) }
              </div>
          </Col>
        </Row>
      </div>

      <DealDetail
        show={showDetail != -1}
        onHide={() => setShowDetail(-1)}
        completed={completed}
        dealId={showDetail}
        itemsPerPage={itemsPerPage}
        selectedExchangeId={selectedExchangeId}
        pageNum={pageNum}
        selectedTab={selectedTab}
        t={t}
      />
    </ContentContainer>
  );
};

export default connect(null, { getDeals,getDealTrades,refreshDealStatus })(Deals);
